
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { palette } from '../../../../assets/theme/theme';
import { genericGet, genericPost } from "../../../../services/api.service";
import OperacaoPecaEntregaDisplay from "./OperacaoPecaEntregaDisplay";
import useForm from '../../../../form/hooks/useForm';
import { useEffect, useState } from 'react';
import { ExpedicoesConfig } from "../../../Peças/Expedicoes/Expedicoes.config";
import { PecaParaOperacaoHeader } from './PecaParaOperacaoHeader';
import { CardStyle } from '../../../../styles/card';





export function PecaParaOperacao({ data, pecaIdx, openIndex, setOpenIndex, setPecasToDisplay }: any) {


    const [expeditionIndex, setExpeditionIndex] = useState<number>(-1);

    const expedicoesForm = useForm({ formConfigs: ExpedicoesConfig });

    useEffect(() => {
        expedicoesForm.init();
    }, [expeditionIndex])


    const DropdownButton = () => {

        return (
            <div
                className='text-white bg-rodrimaq-red border border-rodrimaq-red cursor-pointer rounded-md p-2 mt-2 hover:bg-white hover:text-rodrimaq-red'
                onClick={() => pecaIdx === openIndex ? setOpenIndex(null) : setOpenIndex(pecaIdx)}>   
                 <div className='flex items-center justify-center'>
                    {pecaIdx == openIndex ?<>
                        <VisibilityOffIcon style={{marginRight: 10}}/> Esconder operações </> : 
                        <><VisibilityIcon style={{marginRight: 10}}/> Visualizar operações</>}
                        </div>
            </div>
        )
    }

    const style = () => {
        const obj : any = {
            margin: 20,
            padding: 40,
            paddingBottom: 50
        }
        if(pecaIdx == openIndex) {
            obj['boxShadow'] = '0px 4px 6px -2px #eb4034';
            obj['borderColor'] = '#eb4034';
        }
        return obj;
    }



    return (
        <div key={pecaIdx} style={{
            ...CardStyle,
            ...style()
        }}>


            <div style={{ marginTop: 0 }}>

                    <PecaParaOperacaoHeader
                        data={data}
                        setPecasToDisplay={setPecasToDisplay}
                        operacao={data.peca?.operacoes? data.peca?.operacoes[0] : null}
                    />

                    <DropdownButton/>

                    {pecaIdx === openIndex ?
                        <>
                            <h3 className='font-bold text-[1.4em] my-4'>Lista de operações</h3>
                            {data.peca.operacoes.map((o: any, i: number) => {
                                return (<div>
                                    <OperacaoPecaEntregaDisplay
                                        pecaEntrega={data}
                                        operacao={o}
                                        key={i}
                                        idx={i}
                                        openIndex={openIndex}
                                        pecaEntregaId={data.id}
                                        pecaIdx={pecaIdx}
                                        expeditionIndex={expeditionIndex}
                                        setExpeditionIndex={setExpeditionIndex}
                                        form={expedicoesForm}
                                        setPecasToDisplay={setPecasToDisplay}
                                    />
                                </div>)
                            })}
                        </>
                        : null}

      


            </div>
        </div>

    )

}